import { useUrl } from '@shopify/hydrogen';
import { ComponentProps, FC, ReactElement, useContext, useEffect } from 'react';
import { Parallax, ParallaxContext } from 'react-scroll-parallax';

interface Props extends ComponentProps<typeof Parallax> {
  fallback?: ReactElement;
}

export const SafeParallax: FC<Props> = ({ fallback, ...props }) => {
  const parallaxController = useContext(ParallaxContext);
  const url = useUrl();

  useEffect(() => {
    parallaxController?.update();
  }, [url.pathname]);

  return parallaxController ? <Parallax {...props} /> : <div>{fallback}</div>;
};
